import { countryCallingCodes } from "@utils/CountryCallingCodes";

export class PhoneHelper {
  static removePhoneWhitespace = (phone?: string): string | undefined => {
    if (!phone) {
      return undefined;
    }

    if (phone === "Expert-comptable" || phone === "Utilisateur Jesignexpert") {
      return phone;
    } else {
      return phone.replace(/ /g, "");
    }
  };

  static formatPhone = (phone: string): string => {
    let res = phone;
    if (phone === null) {
      return res;
    }
    if (phone.length < 10) {
      return res;
    }
    if (phone.includes("*")) {
      const match = phone.match(/.{1,2}/g);
      return match ? match.join(" ") : "";
    }
    res = phone.replace(/ /g, "");
    let start = phone.substring(0, 2);
    if (start === "06" || start === "07") {
      return res.replace(/\B(?=(\d{2})+(?!\d))/g, " ");
    }
    if (!phone.startsWith("+")) {
      return phone;
    }
    start = phone.substring(0, 3);
    if (start === "+33") {
      const spacedRest = res.substring(3).replace(/\B(?=(\d{2})+(?!\d))/g, " ");
      return `${start} ${spacedRest}`;
    }
    return this.formatInternationalPhone(phone);
  };

  static formatInternationalPhone = (phone: string): string => {
    const matchingPrefix = countryCallingCodes
      // toSorted not working on some nodeJS version (chrome/firefox/edge)
      .sort((a, b) => b.length - a.length)
      .find((prefix) => phone.startsWith(prefix));

    if (!matchingPrefix) return phone;

    const rest = phone.substring(matchingPrefix.length);
    const spacedRest = rest.replace(/\B(?=(\d{2})+(?!\d))/g, " ");

    return `${matchingPrefix} ${spacedRest}`;
  };
}
